export const medicalOptions = [
  { value: 0, label: "$0" },
  { value: 5000, label: "$5,000" },
  { value: 10000, label: "$10,000" },
];
